import React, { useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";

import ContactService from "../../services/contact.service";
import DataTableDisplay from "../../component/dataTableDisplay";
import { showErrorToaster } from "../../component/toasters/error";

const contactService = new ContactService();

function ContactFormListe() {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const navigate = useNavigate();

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await contactService.getAllContactForm();
      setContacts(res?.data || []);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  useLayoutEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columnsContacts = [
    {
      name: "Nom et Prénom",
      selector: (row) => row?.fullName,
      sortable: true,
    },
    {
      name: "Entreprise",
      selector: (row) => row?.company,
      sortable: true,
    },
    {
      name: "Fonction",
      selector: (row) => row?.position,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Téléphone",
      selector: (row) => row?.phone,
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => row?.message,
    },
  ];

  return (
    <section className="usersPage card-globale">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3 className="title-liste-admin">Liste des contacts</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center my-5">
            <p>Chargement en cours...</p>
          </div>
        ) : (
          <div className="my-5 py-2">
            <DataTableDisplay columns={columnsContacts} data={contacts} />
          </div>
        )}
      </div>
    </section>
  );
}

export default ContactFormListe;
